export const T_IAuthorizationHolder = Symbol('IAuthorizationHolder');
export const T_IBalanceUpdater = Symbol('IBalanceUpdater');
export const T_IBalanceUpdaterRegistrator = Symbol('IBalanceUpdaterRegistrator');
